import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ad7335c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white website-visitors radius-7 billing-card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "billing-card__header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title fw-bold mb-0" }, "Meta de faturamento")
], -1))
const _hoisted_4 = { class: "billing-card__summary" }
const _hoisted_5 = { class: "billing-card__summary-item billing-card__summary-item--success" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Entradas", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "billing-card__scope-note" }, "Somente usuários permitidos.", -1))
const _hoisted_8 = { class: "billing-card__summary-item billing-card__summary-item--goal" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Meta da empresa", -1))
const _hoisted_10 = {
  key: 0,
  id: "websiteVisitorsChart",
  class: "chart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(_ctx.getMetricsMonthBillingGraphic.invoicing)), 1),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(_ctx.getMetricsMonthBillingGraphic.goal)), 1)
        ])
      ]),
      (_ctx.getMetricsMonthBillingGraphic)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_apexchart, {
              key: "billing-chart",
              type: "bar",
              height: _ctx.chartHeight,
              options: _ctx.chartOptions,
              series: _ctx.chartSeries
            }, null, 8, ["height", "options", "series"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}